
import Modules from '@/components/Modules'
import Footer from '@/components/Footer'
import PageTop from '@/components/pages/PageTop'

export default {
  components: {
    Modules,
    PageTop,
    Footer,
  },
  layout: 'default',
  props: ['error'],
  computed: {
    page() {
      return this.$store.state.errorPage
    },
  },
}
